jQuery(document).ready(function ($) {
    window.scrollTo(0, 0);

    let lastScrollY = 0;
    const header = document.querySelector(".header");
    const triggerPoint = 100;
    let scroll = null;

    function initLocomotiveScroll() {

        if (scroll) {
            console.log("Scroll already initialized");
            return;
        }
        scroll = new LocomotiveScroll({
            el: document.querySelector("[data-scroll-container]"),
            inertia: 1,
            smooth: true,
            getDirection: true,
            mobile: {
                inertia: 1,
                breakpoint: 0,
                smooth: false,
                getDirection: true,
                direction: "vertical",
            },
            tablet: {
                inertia: 1,
                breakpoint: 0,
                smooth: false,
                getDirection: true,
                direction: "vertical",
            },
        });


        scroll.on("scroll", (obj) => {
            const currentScrollY = obj.scroll.y;

            if (currentScrollY > lastScrollY) {
                header.classList.add("hidden");
                header.classList.remove("scrolled-up");
            } else {
                header.classList.remove("hidden");
                if (currentScrollY > triggerPoint) {
                    header.classList.add("scrolled-up");
                } else {
                    header.classList.remove("scrolled-up");
                }
            }

            lastScrollY = currentScrollY;
            if (document.body.classList.contains("page__home")) {
                let heroSection = document.querySelector(".hero-section__home");
                const titleWrap = document.querySelector(".title-wrap-home");
                const titleH1 = titleWrap.querySelector(".title");
                const titleH5 = titleWrap.querySelector(".subtitle");
                titleWrap.style.position = "relative";

                let isActive = false;

                let scrollY = obj.scroll.y;
                let heroTop = heroSection.getBoundingClientRect().top;
                let heroBottom = heroTop + heroSection.offsetHeight;
                let viewportTop = 0;
                let viewportBottom = window.innerHeight;

                if (heroBottom > viewportTop - 50 && heroTop < viewportBottom + 50) {
                    if (!isActive) {
                        isActive = true;
                    }

                    let maxScroll = window.innerHeight * 0.5;
                    let progress = Math.min((scrollY - heroTop) / maxScroll, 1);
                    let newScale = 1 - 0.1 * progress;
                    let newOpacity = 1 - 0.7 * progress;
                    let newTranslateY = 200 * progress;

                    gsap.to([titleH1, titleH5], {
                        scale: newScale,
                        opacity: newOpacity,
                        y: newTranslateY,
                        ease: "none",
                        force3D: true,
                        overwrite: true,
                        duration: 0.1,
                    });
                } else if (isActive) {
                    isActive = false;
                    gsap.to([titleH1, titleH5], {
                        scale: 1,
                        opacity: 1,
                        y: 0,
                        duration: 0.2,
                    });
                }
            } else if (document.body.classList.contains("page__cases")) {
                let heroSection = document.querySelector(".banner1");
                const titleWrap = document.querySelector(".text-wrap");
                const titleH1 = titleWrap.querySelector(".cases-text-project");
                const titleH5 = titleWrap.querySelector(".scroll__wrapper");
                titleWrap.style.position = "relative";

                let isActive = false;

                let scrollY = obj.scroll.y;
                let heroTop = heroSection.getBoundingClientRect().top;
                let heroBottom = heroTop + heroSection.offsetHeight;
                let viewportTop = 0;
                let viewportBottom = window.innerHeight;

                if (heroBottom > viewportTop - 50 && heroTop < viewportBottom + 50) {
                    if (!isActive) {
                        isActive = true;
                    }

                    let maxScroll = window.innerHeight * 0.5;
                    let progress = Math.min(
                        Math.max((scrollY - heroTop) / maxScroll, 0),
                        1
                    );
                    let newScale = 1 - 0.1 * progress;
                    let newOpacity = 1 - 0.7 * progress;
                    let newTranslateY = 200 * progress;

                    gsap.to([titleH1, titleH5], {
                        scale: newScale,
                        opacity: newOpacity,
                        y: newTranslateY,
                        ease: "none",
                        force3D: true,
                        overwrite: true,
                        duration: 0.1,
                    });
                } else if (isActive) {
                    isActive = false;
                    gsap.to([titleH1, titleH5], {
                        scale: 1,
                        opacity: 1,
                        y: 0,
                        duration: 0.2,
                        onComplete: () => {
                            gsap.set([titleH1, titleH5], {
                                clearProps: "transform, opacity, scale",
                            });
                        },
                    });
                }
            }
        });
    }

    window.addEventListener("load", function () {
        setTimeout(() => {
            if (scroll) {
                scroll.scrollTo(0, { duration: 0, disableLerp: true });
                scroll.update();
            } else {
                initLocomotiveScroll();
            }
        }, 10);
    });


    const classesGrid1 = ["img-M right", "img-S left", "img-L middle"];
    const classesGrid2 = [
        "img-M left2",
        "img-S right2",
        "img-L middle2",
        "img-S left3",
    ];

    const initialHTML = $(".inside-cases").html();
    const allProjects = [];

    $(".project").each(function () {
        const projectData = {
            html: $(this).prop("outerHTML"),
            category: $(this).data("category"),
        };
        allProjects.push(projectData);
    });

    $(".filter-button").click(function () {
        const category = $(this).data("category");

        if (category === "all") {
            $(".inside-cases").html(initialHTML);
        } else {
            const filteredProjects = allProjects.filter(
                (project) => project.category === category
            );
            $(".inside-cases").empty();

            let currentWrapper = 1;
            let projectsInWrapper = 0;
            const wrapperClasses = [classesGrid1, classesGrid2];

            filteredProjects.forEach((projectData) => {
                const currentClasses = wrapperClasses[currentWrapper - 1];
                const classesCount = currentClasses.length;

                if (projectsInWrapper % classesCount === 0) {
                    if (projectsInWrapper !== 0) {
                        $(".inside-cases").append("</div>");
                    }
                    $(".inside-cases").append(
                        '<div class="wraper-grid-' + currentWrapper + '"></div>'
                    );
                }

                const newClass =
                    currentClasses[projectsInWrapper % classesCount] + " project";

                const projectHtml = $(projectData.html);
                projectHtml.removeClass().addClass(newClass);
                setTimeout(() => {
                    projectHtml.addClass("is-inview");
                }, 100);
                projectHtml.find("div").first().removeClass().addClass("img");

                const wrapperSelector = ".wraper-grid-" + currentWrapper;
                $(wrapperSelector).last().append(projectHtml);

                projectsInWrapper++;

                if (projectsInWrapper % classesCount === 0) {
                    currentWrapper = currentWrapper === 1 ? 2 : 1;
                    projectsInWrapper = 0;
                }
            });

            if (projectsInWrapper !== 0) {
                $(".inside-cases").append("</div>");
            }
        }

        $(".filter-button").removeClass("active");
        $(this).addClass("active");

        setTimeout(() => {
            if (scroll) {
                scroll.update();
            }
        }, 100);
    });

    $(".go-top").on("click", function (e) {
        e.preventDefault();
        scroll.scrollTo(0);
    });

    $(".scroll").on("click", function (e) {
        e.preventDefault();
        let targetPosition = $("#filter-section").offset();
        scroll.scrollTo(targetPosition.top - 100);
    });

    var $customCursor = $(".custom-cursor");
    var $fixedCustomCursor = $(".fixed-custom-cursor");
    var $fixedCustomCloseCursor = $(".custom-cursor-img");
    $(document).on("mousemove", function (e) {
        if ($(".copy-text:hover").length > 0) {
            $customCursor.show();
            gsap.to($customCursor, {
                top: e.pageY - 35 + "px",
                left: e.pageX - 75 + "px",
                duration: 0.25,
                ease: "power2.out",
            });
        } else {
            $customCursor.hide();
        }

        var footerHeight = window.innerHeight;
        if ($("#fixed-footer .copy-text:hover").length > 0) {
            $fixedCustomCursor.show();
            gsap.to($fixedCustomCursor, {
                top: e.clientY - (footerHeight - 325) + "px",
                left: e.clientX - 100 + "px",
                duration: 0.25,
                ease: "power2.out",
            });
        } else {
            $fixedCustomCursor.hide();
        }

        if ($(".fixed__close-section:hover").length > 0) {
            $fixedCustomCloseCursor.show();
            gsap.to($fixedCustomCloseCursor, {
                top: e.clientY + "px",
                left: e.clientX + "px",
                duration: 0.25,
                ease: "power2.out",
            });
        } else {
            $fixedCustomCloseCursor.hide();
        }

    });

    $(".copy-text").on("click", function (e) {
        e.preventDefault();
        var textToCopy = $(this).text();
        var tempElement = $("<textarea>");
        $("body").append(tempElement);
        tempElement.val(textToCopy).select();
        document.execCommand("copy");
        tempElement.remove();

        $customCursor.text("Copied").addClass("copied");
        $fixedCustomCursor.text("Copied").addClass("copied");
        setTimeout(function () {
            $customCursor.text("Copy to clipboard").removeClass("copied");
            $fixedCustomCursor.text("Copy to clipboard").removeClass("copied");
        }, 2000);
    });

    $(".mob-menu button").click(function () {
        $("html").css("overflow", "hidden");
        $(".header-mobile").addClass("active");
        $(".header-mobile .wrap-mobile-header .inside-mobile-header").addClass("is-inview");
        $("body").addClass("menu-active");
    });

    $(".header-mobile .close-btn").click(function () {
        $("html").css("overflow", "auto");
        $(".header-mobile").removeClass("active");
        $(".header-mobile .wrap-mobile-header .inside-mobile-header").removeClass("is-inview");
        $("body").removeClass("menu-active");
    });

    $(".home .header-mobile .wrap-mobile-header .inside-mobile-header .top-section p a").click(function (e) {
        e.preventDefault();
        $(".header-mobile").removeClass("active");
        $("html").css("overflow", "auto");
        setTimeout(() => {
            window.location.href = $(this).attr("href");
        }, 300);
    });

    function getFooterSelector() {
        return $(window).width() <= 768
            ? "#fixed-footer__mobile .footer-mobile"
            : "#fixed-footer .footer";
    }

    function getWrapperSelector() {
        return $(window).width() <= 768 ? "#fixed-footer__mobile" : "#fixed-footer";
    }

    $(document).on("keydown", function (event) {
        let footerWrapper = getWrapperSelector();
        let footer = getFooterSelector();

        if ($(footerWrapper).hasClass("show") && event.key === "Escape") {
            scroll.update();

            $("#fixed-footer").removeClass("show");
            $(footerWrapper).addClass("hide");
            setTimeout(function () {
                $(footer + ", " + footerWrapper).removeClass("show hide");
                $(footer + " [data-scroll]").removeClass("is-inview");
                setTimeout(() => {
                    $(footerWrapper).addClass("hide-hidden");
                }, 600);
                scroll.start();
            }, 0);
        }
    });

    function showFooter() {
        let footerWrapper = getWrapperSelector();
        let footer = getFooterSelector();
        if ($(window).width() <= 768) {
            $(".header-mobile").removeClass("active");
        }
        $(footerWrapper).removeClass("hide-hidden");

        $(footer + ", " + footerWrapper)
            .removeClass("hide")
            .addClass("show");
        $(footer + " [data-scroll]").addClass("is-inview");
        scroll.stop();
    }

    $(".contact-menu a").on("click", function () {
        showFooter();
    });

    $(".close-fixed-footer, .fixed__close-section").on("click", function (e) {
        e.preventDefault();
        $("#fixed-footer").removeClass("show");
        let footerWrapper = getWrapperSelector();
        let footer = getFooterSelector();

        if( $(window).width() <= 768) {
            $('html').css('overflow', 'auto');
            $("body").removeClass("menu-active");
        }

        $(footerWrapper).addClass("hide");
        setTimeout(function () {
            $(footer + ", " + footerWrapper).removeClass("show hide");
            $(footer + " [data-scroll]").removeClass("is-inview");
            setTimeout(() => {
                $(footerWrapper).addClass("hide-hidden");
            }, 600);
            scroll.start();
        }, 0);
    });

    $(".playVimoeButton, .video-wrap").each(function () {
        var $wrapper = $(this);
        var iframe = $wrapper.find("iframe")[0];
        var player = new Vimeo.Player(iframe);
        var $playPauseWrapper = $wrapper.find(".button-wraper");
        var $playPauseButton = $wrapper.find("#playPauseButton");
        var $playContent = $wrapper.find(".play-content");
        var $pauseContent = $wrapper.find(".pause-content");
        var isPlaying = false;

        $wrapper.on("click", function (e) {
            if ($(e.target).closest(".button-wraper").length) return;

            if (isPlaying) {
                player.pause();
            } else {
                player.play();
            }
        });

        $playPauseButton.on("click", function (e) {
            e.stopPropagation();
            if (isPlaying) {
                player.pause();
            } else {
                player.play();
            }
        });

        player.on("play", function () {
            isPlaying = true;
            $playContent.hide();
            $pauseContent.show();
            $playPauseWrapper.addClass("hidden");
        });

        player.on("pause", function () {
            isPlaying = false;
            $playContent.show();
            $pauseContent.hide();
            $playPauseWrapper.removeClass("hidden");
        });

        $wrapper.hover(
            function () {
                $playPauseWrapper.removeClass("hidden");
            },
            function () {
                if (isPlaying) {
                    $playPauseWrapper.addClass("hidden");
                }
            }
        );
    });
    $(document).ready(function () {
        function adjustIframeSize() {
            $(
                ".hero__iframe__wrapper, .iframe__wrapper_hero-home, .iframe__wrapper_section"
            ).each(function () {
                var $wrapper = $(this);
                var wrapperWidth = $wrapper.width();
                var wrapperHeight = $wrapper.height();
                var iframe = $wrapper.find("iframe");
                var videoAspectRatio = iframe.data("aspect-ratio");

                if (!videoAspectRatio) {
                    videoAspectRatio = 16 / 9;
                } else {
                    videoAspectRatio = eval(videoAspectRatio);
                }

                var wrapperAspectRatio = wrapperWidth / wrapperHeight;
                var scaleFactor = Math.max(
                    wrapperAspectRatio / videoAspectRatio,
                    videoAspectRatio / wrapperAspectRatio
                );

                iframe.css({
                    transform: `translate(-50%, -50%) scale(${scaleFactor})`,
                    "object-fit": "cover",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    "transform-origin": "center",
                });
            });
        }

        function fitIframeVideo($wrapper) {
            var $iframe = $wrapper.find("iframe");
            if (!$iframe.length) return;

            $iframe.removeAttr("width").removeAttr("height");

            var videoRatio = 16 / 9;
            var attrW = $iframe.attr("data-width") || $iframe.attr("width");
            var attrH = $iframe.attr("data-height") || $iframe.attr("height");

            if (attrW && attrH) {
                videoRatio = parseFloat(attrW) / parseFloat(attrH);
            }

            var containerW = $wrapper.width();
            var containerH = $wrapper.height();
            if (!containerW || !containerH) return;

            if ($(window).width() <= 768) {
                var wrapperAspectRatio = containerW / containerH;
                var scaleFactor = Math.max(
                    wrapperAspectRatio / videoRatio,
                    videoRatio / wrapperAspectRatio
                );

                $iframe.css({
                    width: "100%",
                    height: "100%",
                    transform: `scale(${scaleFactor})`,
                    "object-fit": "cover",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    "transform-origin": "center",
                    translate: "-50% -50%",
                });

                $wrapper.css({
                    position: "relative",
                    overflow: "hidden",
                });
            } else {
                if (containerW / containerH > videoRatio) {
                    $iframe.css({ height: "100%", width: "auto" });
                } else {
                    $iframe.css({ width: "100%", height: "auto" });
                }
            }
        }

        function adjustAllVideos() {
            $(".video-wrapper").each(function () {
                fitIframeVideo($(this));
            });
        }

        function initVideoScaling() {
            adjustIframeSize();
            adjustAllVideos();
        }

        function checkVisibility() {
            if (
                $(".hero__iframe__wrapper").is(":visible") ||
                $(".iframe__wrapper_hero-home").is(":visible") ||
                $(".iframe__wrapper_section").is(":visible")
            ) {
                initVideoScaling();
            } else {
                setTimeout(checkVisibility, 100);
            }
        }

        checkVisibility();

        $(window).on("resize orientationchange", function () {
            initVideoScaling();
        });
        $(window).on("resize", function () {
            console.log("Window resized, updating scroll");
            scroll.update();
        });

        function safeScrollUpdate() {
            if (typeof scroll !== "undefined") {
                scroll.update();
            }
        }

        setInterval(safeScrollUpdate, 20 * 60 * 1000);

        $(window).on("focus", function () {
            safeScrollUpdate();
        });
    });

 
    if (window.innerWidth <= 768) {
        function adjustIframeSize() {
            $(".iframe__wrapper, .iframe__wrapper_section").each(function () {
                var $wrapper = $(this);
                var wrapperWidth = $wrapper.width();
                var wrapperHeight = $wrapper.height();
                var iframe = $wrapper.find("iframe");
                var videoAspectRatio = iframe.data("aspect-ratio");
                if (!videoAspectRatio) {
                    videoAspectRatio = 16 / 9;
                } else {
                    videoAspectRatio = eval(videoAspectRatio);
                }
                var wrapperAspectRatio = wrapperWidth / wrapperHeight;
                var scaleFactor = Math.max(
                    wrapperAspectRatio / videoAspectRatio,
                    videoAspectRatio / wrapperAspectRatio
                );
                if (scaleFactor > 2.5 && scaleFactor < 2.6) {
                    scaleFactor = 1.5;
                }
                iframe.css("transform", `translate(-50%, -50%) scale(${scaleFactor})`);
            });
        }
        adjustIframeSize();
        $(window).on("resize", adjustIframeSize);
    }

    const single_hero__iframe__wrapper = document.querySelector(
        ".single-project .hero__iframe__wrapper"
    );
    const singleBannerIframeHero = document.getElementById("singleBannerIframeHero");

    if (!single_hero__iframe__wrapper || !singleBannerIframeHero) {
        console.warn("Wrapper or iframe not found.");
        return;
    }

    const player = new Vimeo.Player(singleBannerIframeHero);
    $(".single-project .hero__iframe__wrapper").click(function (e) {
        e.preventDefault();
        player.on("play", () => {
            isPlaying = true;
        });
    });
    $('.mute-content').addClass("hide");
    $(".audio-button-wraper").click(function (e) {
        e.stopPropagation();
        if ($('.mute-content').hasClass("hide")) {
            player.setVolume(1);
            console.log("Unmuting audio");
        } else {
            player.setVolume(0);
            console.log("Muting audio");
        }
        $('.mute-content').toggleClass("hide");
        $('.unmute-content').toggleClass("hide");
    })

});
